module.exports = __webpack_public_path__ + "img/dplius-button.4999870.svg";